import { getDisplayAnswers } from "../../ConnectedQuizStudent/CQStudentQuiz/utils";
<style></style>;
export const RenderAnswers = ({ question }) => {
  const answers = getDisplayAnswers(question);

  return (
    <span
      className="cqProfQuizResultAnsTxt selected-answers"
      style={{ display: "flex", flexDirection: "row" }}
    >
      {answers.map((ans, idx) => (
        <span key={idx} style={{ display: "flex", gap: "2px" }}>
          {ans.type === "answer" ? (
            <div style={{ display: "flex", gap: "6px" }}>
              {ans.correct ? (
                <i
                  className="fas fa-check cqProfQuizResultCheckIcon"
                  title="Correct answer"
                  style={{ width: "12px" }}
                />
              ) : (
                <i
                  className="fas fa-times cqProfQuizResultCheckIcon text-danger"
                  title="Incorrect answer"
                  style={{ width: "12px" }}
                />
              )}
              <span
                style={{
                  marginLeft: "6px",
                  textAlign: "left",
                }}
              >
                {ans.label}
              </span>
            </div>
          ) : (
            <>
              <i
                className="fas fa-times cqProfQuizResultCheckIcon text-danger"
                title="Not answered"
                style={{ width: "12px" }}
              />
              <span style={{ paddingLeft: "6px" }}>N/A</span>
            </>
          )}

          {idx < answers.length - 1 && <span> ,&nbsp;</span>}
        </span>
      ))}
    </span>
  );
};
